import { render, staticRenderFns } from "./shebeiAuth.vue?vue&type=template&id=54ef75aa&scoped=true&"
import script from "./shebeiAuth.vue?vue&type=script&lang=js&"
export * from "./shebeiAuth.vue?vue&type=script&lang=js&"
import style0 from "./shebeiAuth.vue?vue&type=style&index=0&id=54ef75aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef75aa",
  null
  
)

export default component.exports